<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="formFields"
                      :permission="permission"
                      :url="url"
                      :operate="[]"
                      :searchs="searchs"
        />
    </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";
export default {
    name: "Mining",
    components: { CommonTable },
    data() {
        return {
            searchs: [{
                name: 'agentId',
                placeholder: '代理',
                type: 'select',
                selectUrl: '/agent/getAll',
                selectData: [],
            }, {
                name: 'phone',
                placeholder: '用户',
                type: 'input'
            }, {
                name: 'receive',
                placeholder: '请选择状态',
                type: 'select',
                selectValue:[{
                    key: 0,
                    value: '未接收'
                },{
                    key: 1,
                    value: '已接收'
                }]
            }, {
                name: 'startTime',
                placeholder: '开始时间',
                type: 'dateTime'
            }, {
                name: 'endTime',
                placeholder: '结束时间',
                type: 'dateTime'
            }],
            permission: {
                add: 'mining:add',
                update: 'mining:update',
                delete: 'mining:delete',
                deleteBatch: 'mining:deleteBatch'
            },
            url: {
                get: '/mining/listByCondition',
                /*add: '/mining/add',
                update: '/mining/update',
                delete: '/mining/delete',
                delete_batch: '/mining/deleteBatch',*/
            },
            tableColumns: [{
                field: 'id',
                label: 'ID',
                show: true,
                width: '',
            }, {
                field: 'cloudMiningId',
                label: '云矿ID',
                show: false,
                width: '',
            }/*, {
                field: 'userId',
                label: '用户昵称',
                selectUrl: '/userInfo/getAll',
                show: {
                    type: 'select'
                },
                selectData: [],
                width: '',
            }*/, {
                field: 'agentId',
                label: '代理',
                selectUrl: '/agent/getAll',
                selectData: [],
                show: {
                    type: 'select',
                },
                detail: false,
                width: '',
            }, {
                field: 'phone',
                label: '用户',
                show: true,
                width: '',
            }, {
                field: 'money',
                label: '金额(USDT)',
                show: true,
                width: '',
            }, {
                field: 'ratio',
                label: '佣金比例',
                show: true,
                detail: false,
                width: '',
            }, {
              field: 'current',
              label: '货币',
              show: true,
              detail: false,
              width: '',
            }, {
              field: 'site',
              label: '购买平台',
              show: true,
              detail: false,
              width: '',
            }, {
              field: 'saleSite',
              label: '销售平台',
              show: true,
              detail: false,
              width: '',
            }, {
              field: 'payAmount',
              label: '买入价',
              show: true,
              detail: false,
              width: '',
            }, {
                field: 'receive',
                label: '是否接收',
                show: {
                    type: 'tag',
                    tags: [{
                        key: 1,
                        value: '已接收',
                        type: 'success'
                    }, {
                        key: 0,
                        value: '未接收',
                        type: 'warning'
                    }]
                },
                width: '',
            }, {
                field: 'createTime',
                label: '创建时间',
                show: true,
                width: '',
            }],
            formFields: {
                addTitle: '添加收益',
                updateTitle: '修改收益',
                labelWidth: '105px',
                model: [{
                    field: 'userId',
                    label: '选择会员：',
                    type: 'select',
                    //selectUrl: '/userInfo/getAll',
                    selectData: [],
                    placeholder: '请选择会员',
                    rules: [{
                        message: '请选择会员',
                        trigger: 'blur',
                        required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'money',
                    label: '金额：',
                    type: 'money',
                    placeholder: '请输入金额',
                    rules: [{
                        message: '请输入金额',
                        trigger: 'blur',
                        required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'ratio',
                    label: '佣金比例：',
                    type: 'money',
                    placeholder: '佣金比例',
                    rules: [{
                        message: '请输入佣金比例',
                        trigger: 'blur',
                        required: true
                    }],
                    add: true,
                    update: true,
                }]
            }
        }
    }
}
</script>

<style scoped>

</style>
